'use client';

import { useState } from 'react';

import { Box, Container } from '@mui/material';

import { CustomerElearning } from 'src/sections/landing/components/customer-elearning';
import { CenterRegisterForm } from 'src/sections/landing/components/center-register-form';
import { TestimonialElearning } from 'src/sections/landing/components/testimonial-elearning';

import { IntroStudentManage } from '../components/intro-student-manage';
import { DetailStudentManageFunction } from '../components/detail-student-manage-function';
import { StartWithCenterUpStudentManage } from '../components/start-with-center-up-student-manage';

export const StudentManageView = () => {
  const [openDemo, setOpenDemo] = useState<boolean>(false);
  return (
    <Box sx={{ overflowX: 'hidden', width: 1 }}>
      <Container>
        <IntroStudentManage setOpenDemoForm={() => setOpenDemo(true)} />
        <CustomerElearning />
        <DetailStudentManageFunction />
      </Container>
      <TestimonialElearning />
      <Container>
        <StartWithCenterUpStudentManage setOpenDemoForm={() => setOpenDemo(true)} />
      </Container>
      {openDemo && <CenterRegisterForm open={openDemo} onClose={() => setOpenDemo(false)} />}
    </Box>
  );
};
